"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoritesTagService = void 0;
const buildDataLayer = (action, label) => ({
    event: 'analytics-event',
    event_parameters: {
        event_name: `interaction_favoritos_${action}`,
        cd_interaction_detail: label,
    },
});
class FavoritesTagService {
    constructor(vwoService, gaService) {
        this.vwoService = vwoService;
        this.gaService = gaService;
        this.vwoService = vwoService;
        this.gaService = gaService;
    }
    favorite(productSku) {
        this.vwoService.dispatchVWOEvent('addItemToWishlist');
        this.gaService.event(buildDataLayer('adicionar', productSku));
    }
    unfavorite(productSku) {
        this.vwoService.dispatchVWOEvent('removeItemFromWishlist');
        this.gaService.event(buildDataLayer('remover', productSku));
    }
}
exports.FavoritesTagService = FavoritesTagService;
